import permissions from '../../permissions'

const INTEGRATION_PARTNER_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.LIST,
    tag: permissions.INTEGRATION_PARTNERS.LIST,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.SHOW,
    tag: permissions.INTEGRATION_PARTNERS.SHOW,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.CREATE,
    tag: permissions.INTEGRATION_PARTNERS.CREATE,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.EDIT,
    tag: permissions.INTEGRATION_PARTNERS.UPDATE,
  },
  {
    name: 'Vincular empresa ao parceiro',
    tag: permissions.INTEGRATION_PARTNERS.LINK_COMPANY,
  },
]

export default INTEGRATION_PARTNER_LIST
